import { render } from "./CodePreview.vue?vue&type=template&id=46fb06d8&scoped=true"
import script from "./CodePreview.vue?vue&type=script&lang=js"
export * from "./CodePreview.vue?vue&type=script&lang=js"

import "./CodePreview.vue?vue&type=style&index=0&id=46fb06d8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46fb06d8"]])

export default __exports__